<template>
    <component :is="as" class="TextClap">
        {{ isClapped ? textClapped : text }}
        <CButton v-if="showButton" class="TextClap--button" variant="primary-link" @click="handleToggleClap">
            {{ buttonText }}
        </CButton>
    </component>
</template>

<script setup lang="ts">
import CButton from '@/components/ui/CButton.vue'
import { computed, ref, useSlots } from 'vue'

interface Props {
    as?: string
    visible?: boolean
    limitCharacters?: number | null
    dots?: string
    buttonMoreText?: string
    buttonLessText?: string
    toggleClap?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    as: 'span',
    visible: false,
    limitCharacters: null,
    dots: '...',
    buttonMoreText: 'viac',
    buttonLessText: 'menej',
    toggleClap: false
})

const slots = useSlots()
const text = ref(((slots.default?.()[0]?.children as string) || '').trim())
const isClapped = ref(!props.visible)

const textClapped = computed(() => {
    if (props.limitCharacters !== null && text.value.length > props.limitCharacters) {
        return text.value.slice(0, props.limitCharacters) + props.dots
    }

    return text.value
})

const showButton = computed(() => {
    const isLimitedAndExceeded = props.limitCharacters !== null && text.value.length > props.limitCharacters
    if (!isLimitedAndExceeded) return false

    return isClapped.value || (!isClapped.value && props.toggleClap)
})

const buttonText = computed(() => {
    if (!props.toggleClap) return props.buttonMoreText
    return isClapped.value ? props.buttonMoreText : props.buttonLessText
})

const handleToggleClap = () => {
    isClapped.value = !isClapped.value
}
</script>

<style scoped>
.TextClap {
    font-size: inherit !important;
    line-height: inherit !important;
    color: inherit !important;

    &--button {
        display: inline;
        font-size: inherit !important;
        line-height: inherit !important;
        min-height: auto !important;
        padding-inline: 0 !important;
        padding-block: 0 !important;
    }
}
</style>
